import { useEffect, useState } from "react";
import api, { extractErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Trash2 } from "lucide-react";

export default function AdminOndemandRiders() {
  const [items, setItems] = useState([]);
  const [max, setMax] = useState(5);
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/merchant/ondemand/riders");
      setItems(data.items || []);
      setMax(data.max || 5);
    } catch (e) {
      toast.error(extractErr(e));
    }
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/merchant/ondemand/riders", form);
      toast.success("Delivery boy added");
      setForm({ name: "", email: "", phone: "", password: "" });
      await load();
    } catch (err) {
      toast.error(extractErr(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/merchant/ondemand/riders/${id}`);
      await load();
    } catch (e) {
      toast.error(extractErr(e));
    }
  };

  return (
    <div className="max-w-3xl space-y-6" data-testid="admin-ondemand-riders">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Delivery boys</h1>
        <p className="text-sm text-slate-500 mt-1">Up to {max} web-panel accounts. They log in at your store URL /deliver (for example /your-store/deliver).</p>
      </div>
      <Card className="p-5">
        <form onSubmit={create} className="grid sm:grid-cols-2 gap-3" data-testid="od-rider-form">
          <div><Label>Name</Label><Input className="mt-1" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div><Label>Email</Label><Input type="email" className="mt-1" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></div>
          <div><Label>Phone</Label><Input className="mt-1" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          <div><Label>Password</Label><Input type="password" className="mt-1" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} /></div>
          <div className="sm:col-span-2">
            <Button type="submit" disabled={busy || items.length >= max} data-testid="od-rider-create">{busy ? "Saving…" : "Create delivery boy"}</Button>
          </div>
        </form>
      </Card>
      <div className="space-y-2">
        {items.map((r) => (
          <Card key={r.id} className="p-4 flex items-center justify-between" data-testid={`od-rider-${r.id}`}>
            <div>
              <div className="font-semibold">{r.name}</div>
              <div className="text-sm text-slate-500">{r.email} {r.phone ? `· ${r.phone}` : ""}</div>
            </div>
            <Button type="button" variant="ghost" size="icon" onClick={() => remove(r.id)} aria-label="Delete"><Trash2 className="w-4 h-4" /></Button>
          </Card>
        ))}
        {!items.length ? <p className="text-sm text-slate-500">No delivery boys yet.</p> : null}
      </div>
    </div>
  );
}
